module.exports = __webpack_public_path__ + "img/Kibana.20caf36f.png";